<template>
	<div>
		<vue-dropzone
			ref="dz"
			id="dz"
			:options="opts"
			v-on:vdropzone-sending="sendingEvent"
			v-on:vdropzone-success="onComplete"
			v-on:vdropzone-error="onError"
			v-on:vdropzone-file-added="onAddFile"
		></vue-dropzone>
	</div>
</template>
<script>
export default {
	props: ["meta", "complete", "error", "acceptedFiles"],
	data() {
		return {
			files: [],
			requests: [],
			uploadID: null,
			key: null,
			opts: {
				url: "/v1/pitch/chunk",
				autoProcessQueue: false,
				maxFiles: 1,
				maxfilesexceeded: file => {
					this.$refs.dz.removeAllFiles();
					this.$refs.dz.addFile(file);
				},
				acceptedFiles: this.acceptedFiles,
				timeout: 300000,
				chunking: true,
				forceChunking: true,
				retryChunks: true,
				chunkSize: 6000000,
				dictDefaultMessage: "Drop files here to upload (size limit: 256MB)"
			}
		};
	},
	created() {
		this.$emit("update:upload", this.upload);
	},

	methods: {
		sendingEvent(file, xhr, formData) {
			for (var key in this.meta) {
				formData.append(key, this.meta[key]);
			}
			formData.append("key", this.key);
			formData.append("uploadID", this.uploadID);
			this.requests.push({"req": xhr, "idx": formData.get("dzchunkindex")})
		},
		upload(uploadKeys) {
			this.uploadID = uploadKeys.uploadID;
			this.key = uploadKeys.key;
			this.$refs.dz.processQueue();
		},
		onComplete() {
			var parts = [];
			for (var r of this.requests) {
				parts.push({"tag": JSON.parse(r.req.response), "idx": r.idx})
			}
			if (this.complete) {
				this.complete(parts);
			}
		},
		onError(file, message) {
			if (this.error) {
				this.error(file, message);
			}
		},
		onAddFile(file) {
			this.$emit("file", file)
		},
	}
};
</script>